import type { ReactNode } from 'react';

export interface CardProps {
  children: ReactNode;
  className?: string;
  /** Optional heading rendered above `children`. */
  title?: ReactNode;
  /** Optional row of action buttons rendered below `children`. */
  actions?: ReactNode;
}

/** Generic surface card with an optional title and actions row. */
export function Card({ children, className, title, actions }: CardProps) {
  const classes = ['zs-card', className ?? ''].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {title !== undefined ? <h3 className="zs-card__title">{title}</h3> : null}
      <div className="zs-card__body">{children}</div>
      {actions !== undefined ? <div className="zs-card__actions">{actions}</div> : null}
    </div>
  );
}
